module.exports = __webpack_public_path__ + "img/wechat.aea7a9df.png";